import type { FC } from "react";

import type { IndexFreshness } from "../../types";

import { formatRelativeTime } from "../../utils/time";
import { Badge } from "./Badge";

export interface IndexFreshnessBadgeProps {
  indexFreshness?: IndexFreshness;
  lastIndexedAt?: number | null;
  className?: string;
}

export const IndexFreshnessBadge: FC<IndexFreshnessBadgeProps> = ({
  indexFreshness,
  lastIndexedAt,
  className,
}) => {
  if (indexFreshness) {
    let variant: "success" | "warning" | "default" = "default";
    if (indexFreshness.state === "OK") {
      variant = "success";
    } else if (indexFreshness.state === "STALE") {
      variant = "warning";
    }

    return (
      <Badge variant={variant} size="sm" className={className ?? ""}>
        {indexFreshness.state === "OK" && "OK"}
        {indexFreshness.state === "STALE" &&
          (indexFreshness.commits_behind !== null
            ? `${indexFreshness.commits_behind} commits behind`
            : "STALE")}
        {indexFreshness.state === "NONE" && "Not indexed"}
      </Badge>
    );
  }

  if (lastIndexedAt) {
    return (
      <Badge variant="default" size="sm" className={className ?? ""}>
        {formatRelativeTime(lastIndexedAt)}
      </Badge>
    );
  }

  return null;
};
